import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import RadioGroup from '../common/RadioGroup';
import { Card, Header, Body, BoldTitle, GreyText, HorizontalDivider } from '../common/Card';

const NoticeOfIncreaseCard = ({ values, setFieldValue }) => {
  // use_n1 and use_n2 are driven by property defaults
  // With an n1 we ask the following questions, if it’s an N2 we don't need to
  const shouldShowNoticeOfIncreaseOptions = values.notice_of_increase.use_n1;

  return shouldShowNoticeOfIncreaseOptions ? (
    <Card>
      <Header>
        <BoldTitle>
          {getTranslatedString('landlordPortal.rentRoll.renewals.noticeOfIncrease.title')}
        </BoldTitle>
      </Header>
      <HorizontalDivider />
      <Body>
        <GreyText>
          {getTranslatedString(
            'landlordPortal.rentRoll.renewals.noticeOfIncrease.moreThanGuideline'
          )}
        </GreyText>
      </Body>
      <Body>
        <RadioGroup
          name={'notice_of_increase.more_than_guideline'}
          value={values.notice_of_increase.more_than_guideline}
          onChange={(val) => setFieldValue('notice_of_increase.more_than_guideline', val)}
        />
      </Body>
      {values.notice_of_increase.more_than_guideline && (
        <>
          <Body>
            <GreyText>
              {getTranslatedString(
                'landlordPortal.rentRoll.renewals.noticeOfIncrease.hasBeenApproved'
              )}
            </GreyText>
          </Body>
          <Body>
            <RadioGroup
              name={'notice_of_increase.has_been_approved'}
              value={values.notice_of_increase.has_been_approved}
              onChange={(val) => setFieldValue('notice_of_increase.has_been_approved', val)}
            />
          </Body>
        </>
      )}
    </Card>
  ) : null;
};

export default NoticeOfIncreaseCard;
